import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useNameFails } from "../../hooks/useNameFails";
import { RoutesMap } from "../../types";
import { CustomForm } from "../../components/common/CustomForm/CustomForm";
import { ApiStatus } from "../../types/api/status";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
import { CustomFormHeader } from "../../components/common/CustomForm/CustomFormHeader";
import { CustomFormBody } from "../../components/common/CustomForm/CustomFormBody";
import { Formik } from "formik";
import { Divider, FormLabel, Grid, TextField } from "@mui/material";
import { CustomFormFooter } from "../../components/common/CustomForm/CustomFormFooter";

type FailFormData ={
    name:string
}

export const FailForm:FC = () => {
    const navigate = useNavigate()
    const { status, selectedNameFail, createNameFailStore2, editNameFailStore } = useNameFails()

    const [isEdit, setIsEdit] = useState<boolean>(false)
    const [data, setData] = useState<FailFormData>({
        name: ''
    });

    useEffect(() => {
        if (Object.entries(selectedNameFail).length > 0) {
            setIsEdit(true)
            setData({
                name: selectedNameFail.name
            })
        }
    }, [])

    const validateForm = (values) => {
        let errors: any = {};
        if (!values.name) errors.name = "Descripción es requerido";
        return errors;
    }

    const onSubmit = async (values) => {
        const payload = {
            name: values.name
        }
        const method = !isEdit ? createNameFailStore2(payload) : editNameFailStore(selectedNameFail.id, payload)
        const response = await method
        if (response === true) {
            navigate({ pathname: RoutesMap.FAIL_LIST })
        }
    }

    const onCancel = async () => {
        navigate({ pathname: RoutesMap.FAIL_LIST })
    }

    return (
        <CustomForm>
            {status === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
            <CustomFormHeader
                title={!isEdit ? 'Nuevo Motivo' : 'Editar Motivo'}
                text={!isEdit ? 'Ingrese los datos del nuevo Motivo' : 'Ingrese los datos del Motivo'}
                goBack={RoutesMap.FAIL_LIST}
            />
            <CustomFormBody>
                <Formik initialValues={data} enableReinitialize validate={(values) => validateForm(values)} onSubmit={onSubmit}>
                    {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{ padding: '20px' }}>
                                    <Grid item container xs={12} spacing={2} sx={{ mt: 2 }}>
                                        <Grid item xs={12}>
                                            <FormLabel>Descripción:</FormLabel>
                                            <TextField
                                                id="name"
                                                type="text"
                                                name="name"
                                                fullWidth
                                                size="small"
                                                value={values.name}
                                                onChange={handleChange}
                                                error={errors.name && touched.name ? true : false}
                                                helperText={errors.name && touched.name ? errors.name : ''}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider/>
                                <CustomFormFooter
                                    buttonType="submit"
                                    confirmText={!isEdit ? 'Guardar' : 'Actualizar'}
                                    cancelText={"Cancelar"}
                                    onConfirm={handleSubmit}
                                    onCancel={onCancel}
                                />
                            </form>
                        )
                    }}
                </Formik>
            </CustomFormBody>
        </CustomForm>
    )
}